import UberEats from 'assets/uber-eats.svg';
import Doordash from 'assets/icon-doordash.svg';
import Grubhub from 'assets/icon-grubhub.svg';
import Slice from 'assets/icon-slice.png';
import Sauce from 'assets/icon-sauce-delivery.svg';

export const DISABLE_ENTITY_NAMES = {
  STORE: 'Store',
  DELIVERY: 'Delivery',
  PICKUP: 'Pickup'
};

export const SAUCE_CHANNEL_NAME = 'Sauce';

export const PROVIDER_LABELS = {
  UE: 'UberEats',
  DD: 'DoorDash',
  GH: 'GrubHub',
  SL: 'Slice'
};

export const PROVIDERS = {
  UBER_EATS: 'UE',
  DOORDASH: 'DD',
  GRUBHUB: 'GH',
  SLICE: 'SL'
};

export const PROVIDER_ICONS = {
  UberEats,
  DoorDash: Doordash,
  GrubHub: Grubhub,
  Slice,
  Sauce
};

export const PROVIDERS_LIST = ['UE', 'DD', 'GH', 'SL'];

export const normalizeProviderName = (name = '') =>
  String(name)
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9]/g, '');

export const providerNamesMatch = (a, b) =>
  normalizeProviderName(a) === normalizeProviderName(b);

export const getProviderIcon = (name) => {
  const normalized = normalizeProviderName(name);
  const iconMap = {
    ubereats: UberEats,
    uber: UberEats,
    doordash: Doordash,
    grubhub: Grubhub,
    slice: Slice,
    sauce: Sauce
  };
  return iconMap[normalized] || null;
};

export const getProviderDisplayName = (name) => {
  const normalized = normalizeProviderName(name);
  const labelMap = {
    ubereats: 'Uber Eats',
    uber: 'Uber Eats',
    doordash: 'DoorDash',
    grubhub: 'GrubHub',
    slice: 'Slice',
    sauce: 'Sauce'
  };
  return labelMap[normalized] || name;
};

export default DISABLE_ENTITY_NAMES;
